import { Box, IconButton, Radio, styled } from "@mui/material";
import { Link } from "react-router-dom";

export const Section = styled('section')(({ theme }) => (props) => ({
    height: 'auto',
    position: 'relative',
    backgroundImage: props.backImage ? `url("${props.backImage}")` : null,
    backgroundSize: "cover",
    backgroundColor: '#F4F4F4',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column-reverse',
        alignItems: 'center',
        padding: '24px  32px'
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        alignItems: 'center',
        padding: '8px'
    }
}))

export const HeaderFlex = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center',
    padding: '48px  96px ',
    [theme.breakpoints.down('md')]: {
        padding: '24px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px',
    },
}))
export const HeaderContent = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    zIndex: '10',
    width: '50%',
    justifyContent: 'center',
    height: '200px',
    [theme.breakpoints.down('xs')]: {
        width: '95%',
        height: 'auto',
        padding:'16px 0'
    },

}))
export const HeaderText = styled('h3')(({ theme }) => (props) => ({
    fontSize: "24px",
    fontWeight: "800",
    color: theme.palette.primary.main,
    margin: '0',
    textAlign: 'center',
    width: '80%',
    [theme.breakpoints.down('xs')]: {
        width: '100%',
    },
}))
export const DiscText = styled('p')(({ theme }) => (props) => ({
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "22px",
    color: '#000000',
    width: '80%',
    textAlign: 'justify',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
        width: '100%',
    },
}))
export const LeftSection = styled('div')(({ theme }) => (props) => ({
    flexDirection: 'column',
    width: '450px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.mode === "light" ? theme.palette.background.light : theme.palette.background.darkSecondary,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '-5px 5px 5px 0px rgba(181, 180, 180, 0.75)',
    padding: '18px  32px ',
    position: 'absolute',
    right: '8%',
    top: '25%',
    [theme.breakpoints.down('lg')]: {
        right: '1%',
        top: '25%',
        width: '420px',
    },
    [theme.breakpoints.down('md')]: {
        position: 'static',
        width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
        alignItems: 'center',
        textAlign: "center"
    },

}))
export const CardSection = styled('div')(({ theme }) => (props) => ({
    flexDirection: 'column',
    width: '95%',
    display: 'flex',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    [theme.breakpoints.down('xs')]: {
        alignItems: 'center',
        textAlign: "center"
    },

}))
export const CardSectionImage = styled('div')(({ theme }) => (props) => ({
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '350px',
    height: '250px',
    background: theme.palette.mode === "light" ? theme.palette.background.lightSecondary : theme.palette.background.darkSecondary,
    borderRadius: theme.shape.borderRadius,
    padding: '18px  32px ',
    [theme.breakpoints.down('xs')]: {
        alignItems: 'center',
        textAlign: "center",
        width: '100%',

    }
}))
export const HrCustom = styled('div')(({ theme }) => (props) => ({
    width: '100%',
    height: '2px',
    background: '#00000029',
    borderRadius: '8px'
}))
export const CardSectionTextPrice = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: "space-evenly",
    padding: '5px',
}))
export const CardTextPriceDisCount = styled('h4')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.text.lightSecondary,
    lineHeight: '29.26px',
    margin: '0',
    textDecoration: "line-through"
}))
export const CardTextPrice = styled('h5')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: '600',
    color: theme.palette.text.lightSecondary,
    lineHeight: '',
    margin: '0'

}))
export const CardText = styled('h5')(({ theme, color }) => (props) => ({
    fontSize: '14px',
    fontWeight: '400',
    color: color,
    lineHeight: '',
    margin: '0'

}))
export const ContentTimeDetails = styled('div')(({ theme, color }) => (props) => ({
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
}))
export const ContentTime = styled('div')(({ theme, color }) => (props) => ({
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '30px',
    [theme.breakpoints.down('xs')]: {
        flexDirection: 'column'
    },
}))
export const ContentTimeSot = styled('div')(({ theme, color }) => (props) => ({
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',


}))
export const IconTimeSot = styled(IconButton)(({ theme, color }) => (props) => ({

}))


export const TitleRaeteng = styled('p')(({ theme }) => (props) => ({
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: '0em',
    // display: 'block',
    color: theme.palette.mode === 'light' ? '#fff' : '',

    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw'

    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    }
}))
export const TextDiscretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '1vw',
    fontWeight: '400',
    letterSpacing: '0em',
    display: 'block',
    color: theme.palette.text.dark,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        fontWeight: '600'
    }
}))
export const ButtonContent = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '16px',
    alignItems: 'center'
}))
export const TextLink = styled(Link)(({ theme }) => (props) => ({
    fontsize: "12px",
    fontWeight: "300",
    color: theme.palette.primary.main,
    textDecoration: 'none'

}))
export const ImgSection = styled('div')(({ theme }) => (props) => ({
    width: '245px',
    height: '245px',
    maxWidth: '245px',
    minWidth: '245px',
    maxHeight: '245px',
    minHeight: '245px',
    [theme.breakpoints.down('md')]: {
        margin: '5vw',
    },
    [theme.breakpoints.down('lg')]: {
        width: '180px',
        height: '180px',
        maxWidth: '180px',
        minWidth: '180px',
        maxHeight: '180px',
        minHeight: '180px',
    },
    [theme.breakpoints.down('sm')]: {
        width: '144px',
        height: '144px',
        maxWidth: '144px',
        minWidth: '144px',
        maxHeight: '144px',
        minHeight: '144px',
    },
    zIndex: '20'
}))
export const Img = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: 10
}))

//Style Radio
export const StyledRadio = styled(Radio)({
    display: 'none',
    '& + .MuiFormControlLabel-label': {
        color: '#828282',
        fontWeight: '500',
        margin: '5px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
    },
    '&.Mui-checked + .MuiFormControlLabel-label': {
        color: '#000',
        fontSize: '16px',
        fontWeight: '600',
    },
});
export const StyledRadioTwo = styled(Radio)({
    '& + .MuiFormControlLabel-label': {
        color: '#828282',
        fontWeight: '400',
        fontSize: '14px',
    },
    '&.Mui-checked + .MuiFormControlLabel-label': {
        color: '#000',
        fontSize: '14px',
        fontWeight: '400',
    },
    '&.Mui-disabled + .MuiFormControlLabel-label': {
        color: '#828282',
        fontWeight: '400',
    },
});